module.exports = __webpack_public_path__ + "img/csm_Ersa-ECOSELECT1-01-900x675_7504332b26.dee66e27.png";